import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useParams, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import Swal from "sweetalert2";

const Bill_add_vehicle = () => {
  useAuthRedirect();
  const { basis, vcode, billNo } = useParams();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [price, setPrice] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const canEntry = hasPermission("Hire Bill Generation", "entry");

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `https://rfs2.infraconsoft.net.in/api/bill_addVehicle?vcode=${vcode}&branch_code=${branch}`
      )
      .then((response) => {
        if (response.data && response.data.addVehicle) {
          setData(response.data.addVehicle);
          setFilteredData(response.data.addVehicle);
          // console.log("Fetched Vehicles:", response.data.addVehicle);
        } else {
          console.warn("No vehicles found in response.");
        }
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [vcode, branch]);

  useEffect(() => {
    axios
      .get(
        `https://rfs2.infraconsoft.net.in/api/bill_price?vcode=${vcode}&branch_code=${branch}`
      )
      .then((response) => {
        // console.log("Full API Response:", response.data);

        if (
          Array.isArray(response.data.vehiclePrice) &&
          response.data.vehiclePrice.length > 0
        ) {
          setPrice(response.data.vehiclePrice[0].fld_vprice);
          console.log(
            "Fetched price:",
            response.data.vehiclePrice[0].fld_vprice
          );
        } else {
          console.warn("fld_vprice is missing or vehiclePrice array is empty.");
          setPrice(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
        setPrice(null);
      });
  }, [vcode, branch]);

  const cumulativeData = useMemo(() => {
    let totalHours = 0;
    let totalTons = 0;
    let totalKm = 0;
    let amt = 0;
    let totamt = 0;
    let totms = 0; 

    return data.map((item) => {
      let wkm = Math.round((item.fld_endkm || 0) - (item.fld_stkm || 0));
      totalKm += wkm;

      if (item.fld_vbasis === "Hour" || item.fld_vbasis === "Kmhour") {
        totalHours += parseFloat(item.fld_wohrs) || 0;
      }
      if (item.fld_vbasis === "Ton") {
        totalTons += parseFloat(item.fld_wokm) || 0;
      }
      if (item.fld_vbasis === "Hour") {
        amt = item.fld_wohrs * price;
        totamt += amt;
      }
      if (item.fld_vbasis === "Kmhour") {
        const workingmins = item.fld_wohrs;
        const workhour = Math.floor(workingmins / 60);
        const workmin = workingmins % 60;
        const worhtot = `${workhour}:${workmin}:00`;

        let totmin1 = workingmins;
        totms += totmin1;
        const tothourbill = Math.floor(totms / 60);
        const minhours = totms % 60;
        const tothour11 = Math.round(minhours * 1.666);
        const tothour21 = `${tothourbill}.${tothour11}`;

        amt = parseFloat(tothour21) * price;
        totamt += amt;
      }
      if (item.fld_vbasis === "Hour") {
        amt = item.fld_wohrs * price;
        totamt += amt;
      }
      if (item.fld_vbasis === "Km") {
        amt = wkm * price;
        totamt += amt;
      }

      if (item.fld_vbasis === "Kmhour") {
        amt = wkm * price;
        totamt += amt;
      }


      if (item.fld_vbasis === "Ton") {
        amt = wkm * item.fld_noloads * price;
        totamt += amt;
      }
      if (item.fld_vbasis === "Month") {
        amt = wkm * item.fld_noloads * price;
        totamt += amt;
      }

      return {
        cumulativeHours: totalHours.toFixed(2),
        cumulativeTons: totalTons.toFixed(2),
        cumulativeKm: totalKm,
        amount: amt,
        totalAmt: totamt,
      };
    });
  }, [data, price])

  
  const handleVehicleSelection = (vehicleId) => {
    console.log("🟢 Selected Vehicle ID:", vehicleId); 
  
    setSelectedItems((prev) =>
      prev.includes(vehicleId)
        ? prev.filter((id) => id !== vehicleId)
        : [...prev, vehicleId]
    );
  
    // console.log("✅ Updated Selected Items:", [...selectedItems, vehicleId]); 
  };
  
  
  const handleSubmit = async () => {
    // console.log("🚀 Sending to backend:", selectedItems);
  
    if (selectedItems.length === 0) {
      Swal.fire("No Selection", "Please select at least one item!", "warning");
      return;
    }
  
    try {

      Swal.fire({
                        title: "Submitting...",
                        text: "Please wait while we process your request.",
                        allowOutsideClick: false,
                        didOpen: () => {
                          Swal.showLoading();
                        },
                      });
                      
      const response = await axios.post("https://rfs2.infraconsoft.net.in/api/store-data", {
        selectedItems,
        vcode,
        billNo,
        branch
      });
  
      console.log("✅ Backend Response:", response.data);
  
      // Show success alert & redirect
      Swal.fire({
        title: "Success!",
        text: "Billing Approved!",
        icon: "success",
        confirmButtonText: "OK"
      }).then(() => {
        navigate(`/generate_bill/${vcode}/${basis}`);

      });
  
      setSelectedItems([]); 
  
    } catch (error) {
      console.error("❌ Error in handleSubmit:", error.response?.data || error.message);
  
      // Show error alert
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message || "Something went wrong!",
        icon: "error",
        confirmButtonText: "OK"
      });
    }
  };
  
  
  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.vehicle &&
          item.vehicle.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.battery_code &&
          item.battery_code
            .toLowerCase()
            .includes(e.target.value.toLowerCase())) ||
        (item.battery_type &&
          item.battery_type
            .toLowerCase()
            .includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                              <h2 className="add-txt">Hire Vehicle Bill Details</h2>
                              <Link to={`/generate_bill/${vcode}/${basis}`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                            </div>
          <Time />
        </section>

        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by vehicleName"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <div className="responsive-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>

                {/* {(basis === "Hour") && (
                  <>
                    <th>Starting Hrs</th>
                    <th>Closing Hrs</th>
                  </>
                )} */}

                {(basis === "Km" || basis === "Kmhour") && (
                  <th>Breaking Hrs</th>
                )}

                {(basis === "Hour") && (
                  <>
                    <th>Working Hrs</th>
                    <th>Cum Hrs</th>
                  </>
                )}

                 

                         

 {(basis === "Km" || basis === "Kmhour" || basis === "Ton" || basis === "Month") && (
  <>
                  <th>Starting KM</th>
                <th>Closing KM</th>
                <th>Working KM</th>
                <th>Cum KM</th>
                </>
                )}

                
                <th>No Of Loads</th>
                <th>Rent</th>

                {["Hour", "Km", "Ton", "Kmhour"].includes(basis) && (
                  <>
                    <th>Amt</th>
                    <th>Cum Amt</th>
                  </>
                )}

                <th>Bill</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="15" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : data.length > 0 ? (
                data.map((item, index) => {
                  let wkm = Math.round(item.fld_endkm - item.fld_stkm);
                  let ff = 0;
                  ff = ff + wkm;

                  let worhtot = "0:00:00",
                    cumhours1 = "0:00:00",
                    tothour21 = "0.00";

                  if (
                    item.fld_vbasis === "Km" ||
                    item.fld_vbasis === "Kmhour"
                  ) {
                    let workingmins = item.fld_wohrs;
                    let workhour = Math.floor(workingmins / 60);
                    let workmin = workingmins % 60;
                    worhtot = `${workhour}:${workmin}:00`;

                    let totmin = workingmins + (item.totm || 0);
                    let tothour = Math.floor(totmin / 60);
                    let min = totmin % 60;
                    cumhours1 = `${tothour}:${min}:00`;

                    let totmin1 = workingmins + (item.totm1 || 0);
                    let tothourbill1 = Math.floor(totmin1 / 60);
                    let minhours1 = totmin1 % 60;
                    cumhours1 = `${tothourbill1}:${minhours1}:00`;

                    let tothour1 = Math.round(minhours1 * 1.666);
                    tothour21 = `${tothourbill1}.${tothour1}`;
                  }

                  let worhtotValue = parseFloat(item.fld_wohrs) || 0;
                  if (item.fld_vbasis === "Hour" || item.fld_vbasis === "Ton") {
                    worhtot = worhtotValue;
                  }

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {new Date(item.fld_vdate).toLocaleDateString("en-GB")}
                      </td>

                      {/* {(item.fld_vbasis === "Hour") && (
                        <>
                          <td>{item.fld_sthrs}</td>
                          <td>{item.fld_endhrs}</td>
                        </>
                      )} */}

                      {(item.fld_vbasis === "Km" ||
                        item.fld_vbasis === "Kmhour") && (
                        <td>
                          {item.fld_brehrs} : {item.fld_bremin}
                        </td>
                      )}

                      {(item.fld_vbasis === "Hour") && (
                        <>
                          <td>{worhtot}</td>
                          <td>{cumulativeData[index]?.cumulativeHours}</td>
                        </>
                      )}



                      {item.fld_vbasis === "Ton" && (
                        <>
                          <td>{item.fld_stkm}</td>
                          <td>{item.fld_endkm}</td>
                          <td>{wkm}</td>
                          <td>{cumulativeData[index]?.cumulativeTons}</td>
                        </>
                      )}

{item.fld_vbasis === "Month" && (
                        <>
                          <td>{item.fld_stkm}</td>
                          <td>{item.fld_endkm}</td>
                          <td>{wkm}</td>
                          <td>{cumulativeData[index]?.cumulativeKm}</td>
                        </>
                      )}


                      {(item.fld_vbasis === "Km" ||
                        item.fld_vbasis === "Kmhour") && (
                        <>
                          <td>{item.fld_stkm}</td>
                          <td>{item.fld_endkm}</td>
                          <td>{wkm}</td>
                          <td>{cumulativeData[index]?.cumulativeKm}</td>
                        </>
                      )}

                      {item.fld_vbasis === "Hour" ? (
                        <td>{item.fld_noload}</td>
                      ) : (
                        <td>{item.fld_loads}</td>
                      )}

                      {item.fld_vbasis === "Month" ? (
                        <td>{price !== null? price.toLocaleString("en-IN", {minimumFractionDigits: 2,}): "N/A"}</td>
                      ) : (
                        <>
                         <td>{price !== null? price.toLocaleString("en-IN", {minimumFractionDigits: 2,}): "N/A"}</td>
                      <td>{cumulativeData[index]?.amount?.toLocaleString("en-IN",{ minimumFractionDigits: 2 }) || "0.00"}</td>
                      <td>{cumulativeData[index]?.totalAmt?.toLocaleString("en-IN",{ minimumFractionDigits: 2 }) || "0.00"}</td>
                        </>
                      )}
                     
                      <td>
                      <input
  type="checkbox"
  checked={selectedItems.includes(item.fld_vid)}
  onChange={() => handleVehicleSelection(item.fld_vid)}
/>

</td>

                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="15">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
        </div>
        <div className="btn-cls">
        <button type="button" className="submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Bill_add_vehicle;
